import TopBar from '../home/components/TopBar';
import Header from '../home/components/Header';
import AdvantagesSection from '../home/components/AdvantagesSection';
import BenefitsSection from '../home/components/BenefitsSection';
import TestimonialsSection from '../home/components/TestimonialsSection';
import Footer from '../home/components/Footer';
import FloatingWhatsApp from '../home/components/FloatingWhatsApp';
import ChatPopup from '../home/components/ChatPopup';

const Vantagens = () => {
  return (
    <div className="min-h-screen bg-white">
      <TopBar />
      <Header />
      
      <div className="py-16">
        <AdvantagesSection />
        <BenefitsSection />
        <TestimonialsSection />
      </div>

      <Footer />
      <FloatingWhatsApp />
      <ChatPopup />
    </div>
  );
};

export default Vantagens;
